import { LegalPage } from "@/components/LegalPage";

const SECTIONS = [
  {
    body: `We offer refund / exchange within first 1 day from the date of your purchase. If 1 day has passed since your purchase, you will not be offered a return, exchange or refund of any kind. In order to become eligible for a return or an exchange:`,
  },
  {
    list: [
      "The purchased item should be unused and in the same condition as you received it.",
      "The item must have its original packaging.",
      "If the item that you purchased was on sale, then the item may not be eligible for a return / exchange.",
      "Only such items are replaced by us (based on an exchange request) if they are found defective or damaged.",
    ],
  },
  {
    body: `You agree that there may be a certain category of products / items that are exempted from returns or refunds. Such categories of products would be identified to you at the time of purchase.`,
  },
  {
    body: `For exchange / return accepted request(s) (as applicable), once your returned product / item is received and inspected by us, we will send you an email to notify you about receipt of the returned / exchanged product. Further, if the same has been approved after the quality check at our end, your request (i.e. return / exchange) will be processed in accordance with our policies.`,
  },
];

export default function Return() {
  return (
    <LegalPage
      title="Return Policy"
      sections={SECTIONS}
      testid="return-page"
    />
  );
}
